import Icon from '../components/Icon.vue'

Icon.register({
  'external-link-square-alt': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 80v352c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM360 96h-112c-21.3 0-32.1 25.9-17 41l32 32-195.5 195.5c-4.7 4.7-4.7 12.3 0 17l31 31c4.7 4.7 12.3 4.7 17 0l195.5-195.5 32 32c15 15 41 4.5 41-17v-112c0-13.3-10.7-24-24-24z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/external-link-square-alt.js
// module id = 1312
// module chunks = 0